.intro {
  margin-bottom: var(--tuna-spacing-2);
}

.row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.5fr);
  align-items: center;
  gap: var(--tuna-spacing-1);
  margin-bottom: var(--tuna-spacing-1);
}

.name {
  overflow-wrap: anywhere;
}

/* Status sits under the select, in the second column. */
.status {
  grid-column: 2;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--tuna-spacing-1);
  margin-top: var(--tuna-spacing-2);
}

@media (max-width: 599.95px) {
  .row {
    grid-template-columns: minmax(0, 1fr);
  }

  .status {
    grid-column: 1;
  }
}
